import { useAppConfigContext } from '~/contexts/AppConfig';
import { FormField } from '~/eds/src/components/FormField/FormField';
import { NumberInput } from '~/eds/src/components/NumberInput/NumberInput';
import { WorkflowFieldType } from '~/enums/WorkflowFieldType';
import { Nullable } from '~/types/Nullable';

import {
  NumberCustomSettings,
  PercentageCustomSettings,
} from '../types/fields';
import { WorkflowQuestionFormField } from './types';

export const NumberWorkflowQuestion = ({
  question,
  onChange,
  type,
  ...rest
}: {
  type: WorkflowFieldType.Number | WorkflowFieldType.Percentage;
} & WorkflowQuestionFormField<Nullable<number>>) => {
  const { isPanelEnlarged } = useAppConfigContext();
  const {
    field: { value, customSettings, wellKnownKey },
  } = question;

  let customSettingsInputProps = {};
  if (type === WorkflowFieldType.Percentage) {
    const { min, max } = customSettings as PercentageCustomSettings;
    customSettingsInputProps = {
      min,
      max,
    };
  } else {
    const { allow_decimals } = customSettings as NumberCustomSettings;
    customSettingsInputProps = {
      allowDecimals: allow_decimals,
      ...(wellKnownKey === 'final_spend' && { min: 0 }),
    };
  }

  return (
    <FormField
      {...rest}
      input={NumberInput}
      value={value.value}
      onChange={(val) => onChange(val, 'value')}
      inputProps={{
        ...customSettingsInputProps,
        width: isPanelEnlarged ? 'input.m.width' : '100%',
      }}
    />
  );
};
